import '../style/components.css';
import Tooltip from './Tooltip';

export default function Icon({ name, tooltip = false }: { name: string, tooltip?: boolean }) {
    const icon = (<div className='icon-div'>
        <img src={`icons/${name}.svg`} />

    </div>)

    if (tooltip) {
        return (
            <Tooltip text={name.split("-")[0]}>
                {icon}
            </Tooltip>
        );
    }
    return icon;
}